/** @format */

import React from "react";
import { Spin } from "antd";
import { useQueryAccounts } from "../../../apis/swr/fetchers";
import LoginChartsContainer from "./LoginCharts/LoginCharts.container";
import LastUsedChartsContainer from "./LastUsedCharts/LastUsedCharts.container";
import SignUpChartsContainer from "./SignUpCharts/SignUpCharts.container";

const ChartsView: React.FC = () => {
	const { isLoading } = useQueryAccounts();

	return (
		<Spin spinning={isLoading} tip="Fetching accounts data...">
			<LoginChartsContainer />
			<SignUpChartsContainer />
			<LastUsedChartsContainer />
		</Spin>
	);
};

export default ChartsView;
